import type { ReactNode } from 'react';
import { PlatformRequireRole } from '@jarvis/platform-ui';
import type { AssistantRole } from './roles';
import { useHasRole } from './useHasRole';

interface RequireRoleProps {
  role: AssistantRole;
  children: ReactNode;
}

/** Gates nested routes when the signed-in user lacks the required Assistant App Role (SPA-side UX guard). */
export function RequireRole({ role, children }: RequireRoleProps) {
  const { hasAssistantRole } = useHasRole();
  return (
    <PlatformRequireRole role={role} hasRole={hasAssistantRole} roleLabel="Assistant App Role">
      {children}
    </PlatformRequireRole>
  );
}
